import React from "react";

import Header from "../components/header";
import HeroSection from "../components/Concierge/buyherosection";
import Cards from "../components/Concierge/concierge-card";
import Whychoose from "../components/Concierge/whychoose";
import FAQ from "../components/Concierge/faq";
import CTA from "../components/Concierge/cta";


import Footer from "../components/footer";

const Home = () => {
  return (
    <>
    
      <Header />
      <HeroSection />
     <Cards />
     <Whychoose/>
     <FAQ/>
     <CTA />
      <Footer />
    </>
  );
};

export default Home;